import BaseMultipleSelectorV2 from "components/base/BaseMultipleSelectorV2";
import { hasError, ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

const ReactHookFormMultipleSelector = ({
  language,
  valueFieldName,
  sourceData: inputSourceData,
  errorId = valueFieldName,
  getSourceDataFromState = (state) => { },
  loadSourceDataAction = () => { },
  loadMoreAction = () => { },
  focusChange = () => { },
  focusKey,
  ...otherProps
}) => {
  const dispatch = useDispatch();
  const { watch, setValue, formState: { errors } } = useFormContext();
  const sourceData = useSelector((state) => getSourceDataFromState(state));

  const targetData = watch(valueFieldName);
  useEffect(() => {
    loadSourceDataAction(dispatch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <BaseMultipleSelectorV2
        data={{
          sourceData: sourceData?.length > 0 ? sourceData : inputSourceData || [],
          targetData: targetData,
          targetChange: (value) => {
            setValue(valueFieldName, value, { shouldDirty: true });
          },
        }}
        loadMoreAction={() => { loadMoreAction(dispatch) }}
        onFocusFunc={() => { focusKey && focusChange(focusKey) }}
        error={{
          error: hasError(errors, errorId)
        }}
        {...otherProps}
      />
      <ReactHookFormErrorMessage errors={errors} id={errorId} />
    </>
  )
}

export default ReactHookFormMultipleSelector;